import { useWarehouseLabels } from '../warehouseLabels';

/**
 * Rótulos da EXPEDIÇÃO (M8).
 *
 * ⚠️ Sem dicionário próprio, de propósito: as 137 chaves do M8 vivem em
 * `warehouseLabels.js`. O console e o coletor falam do MESMO checklist, e dois
 * vocabulários paralelos divergem no primeiro texto ajustado só de um lado
 * (CLAUDE.md §4).
 */
export function useShippingLabels() {
    return useWarehouseLabels();
}
